import axios from "axios";
import { IChat } from "../interfaces/chat";
export const sendChatMessage = async (newChat: IChat) =>
  await axios.post("/chat/doctor", newChat);

export const readChat = async (uid: string) =>
  await axios.get(`/chat/read/${uid}`);
